
import { useState } from 'react';
import { Info } from 'lucide-react';

export default function InfoTooltip({ message = "This is helpful info." }) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <div
        className="info-icon"
        style={{
          backgroundColor: '#e5e7eb',
          borderRadius: '50%',
          width: '20px',
          height: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: 'bold',
          color: '#4B5563'
        }}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        <Info size={12} />
      </div>

      {/* Tooltip */}
      <div
        className="tooltip-content"
        style={{
          position: 'absolute',
          bottom: '125%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#111827',
          color: '#fff',
          padding: '8px 12px',
          borderRadius: '6px',
          fontSize: '12px',
          whiteSpace: 'nowrap',
          opacity: isVisible ? 1 : 0,
          visibility: isVisible ? 'visible' : 'hidden',
          transition: 'opacity 0.3s ease',
          zIndex: 9999,
          pointerEvents: 'none',
          width: '500px',
          maxWidth: '120px',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          lineHeight: '1.4'
        }}
      >
        {message}
      </div>

      {/* Tooltip Arrow */}
      <div
        className="tooltip-arrow"
        style={{
          position: 'absolute',
          bottom: '115%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderTop: '6px solid #111827',
          opacity: isVisible ? 1 : 0,
          visibility: isVisible ? 'visible' : 'hidden',
          transition: 'opacity 0.3s ease',
          pointerEvents: 'none'
        }}
      ></div>
    </div>
  );
}
